import * as yup from 'yup'

const ForgotPasswordValidator  = yup.object({
    email: yup.string().email().required("Email is required"),
})

export { ForgotPasswordValidator }